export const colors = {
  primary: '#2C6496', // PolicyEngine Blue - using for federal/Congressional theme
  secondary: '#39C6C0', // PolicyEngine Teal
  success: '#4CAF50',
  warning: '#FFA726',
  error: '#EF5350',
  text: {
    primary: '#1A1A1A',
    secondary: '#666666',
    disabled: '#999999',
    white: '#FFFFFF'
  },
  background: {
    default: '#F5F5F5',
    paper: '#FFFFFF',
    dark: '#2C6496',
    light: '#E3F2FD'
  },
  border: '#E0E0E0',
  shadow: 'rgba(0, 0, 0, 0.1)',
  chart: {
    positive: '#4CAF50',
    negative: '#EF5350',
    neutral: '#9E9E9E',
    primary: '#2C6496',
    secondary: '#39C6C0',
    tertiary: '#FFA726',
    quaternary: '#AB47BC'
  },
  party: {
    democrat: '#2E5EAA',
    republican: '#E91D0E',
    independent: '#69499E'
  }
};